import React, { useState } from 'react';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import ImpressionComponent from './ImpressionComponent';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 450,
    height: 400,
    padding: 20,
    margin: 5,
    background: 'rgba(255,2555,255,0.5)'
  },
  title: {
    color: '#6D7278',
    fontSize: 14,
    textAlign: 'left'
  },
  select: {
    borderRadius: '5px',
    margin: '15px auto',
    width: '100%',
    '& .MuiOutlinedInput-input': {
      padding: '9.5px 35px 9.5px 10px',
      fontSize: 13
    }
  }
}));

const InvestorsImpression = () => {
  const classes = useStyles();
  const [impression, setImporession] = useState('');

  const handleChangeMonth = (e) => {
    const newImpression = e.target.value;
    setImporession(newImpression);
  };

  const fakeImpressions = [
    { number: '#1', impression: 'Regulation', numOfInvestors: 24 },
    { number: '#2', impression: 'Cost inflation', numOfInvestors: 16 },
    { number: '#3', impression: 'Client concentration', numOfInvestors: 15 },
    { number: '#4', impression: 'Competition', numOfInvestors: 12 },
    { number: '#5', impression: 'Sector', numOfInvestors: 5 }
  ];

  return (
    <Paper className={classes.root} elevation={3}>
      <h6 className={classes.title}>INVESTOR IMPRESSIONS</h6>
      <Select
        className={classes.select}
        inputProps={{
          name: 'impression',
          id: 'impression'
        }}
        native
        onChange={handleChangeMonth}
        value={impression}
        variant="outlined">
        <option value="Appreciation of risk factors">
          Appreciation of risk factors
        </option>
        <option value="Appreciation of risk factors">
          Appreciation of risk factors
        </option>
        <option value="Appreciation of risk factors">
          Appreciation of risk factors
        </option>
      </Select>
      {fakeImpressions.map((impress) => (
        <ImpressionComponent
          impression={impress.impression}
          number={impress.number}
          numOfInvestors={impress.numOfInvestors}
        />
      ))}
    </Paper>
  );
};

export default InvestorsImpression;
